<template>
  <!--批量签章主体内容-->
  <div class="" :class="{'jp-delivery-signature-dark': effect === 'dark'}">
    <div class="jp-reminder-tip-container">
      <i class="el-icon-warning-outline"></i>
      <p class="jp-reminder-tip-content">
        <template v-if="!isUploadModule">
          发起用章申请前，请您对完成签章后<span>是否进行文书的自动送达</span>进行设置
        </template>
        <template v-else>
          在您上传文书包之前，请您对上传后的文书<span>是否进行自动送达</span>进行设置
        </template>
      </p>
    </div>
    <div class="jp-delivery-signature-bg">
      <div class="jp-delivery-signature-box">
        <h3 class="title">
          <template v-if="!isUploadModule">完成签章后，是否自动送达文书</template>
          <template v-else>文书上传成功后，是否进行自动送达</template>
        </h3>
        <div class="jp-delivery-signature-content">
          <div class="jp-delivery-signature-item"
               @click.stop="clickChangeRadio('1')"
               :class="{'is-active': deliveryFlag === '1'}">自动送达</div>
          <div class="jp-delivery-signature-item"
               @click.stop="clickChangeRadio('0')"
               :class="{'is-active': deliveryFlag === '0'}">不自动送达<span>（后续还可手动发起送达）</span></div>
        </div>
      </div>
      <div class="jp-delivery-signature-box jp-delivery-signature-range">
        <div class="jp-delivery-signature-range-content" v-show="deliveryFlag === '1'">
          <h3 class="title">自动送达的文书范围（多选）</h3>
          <div class="jp-delivery-signature-range-checkbox-list">
            <div class="jp-delivery-signature-range-checkbox-item"
                 v-for="(fileTypeItem, fileTypeIndex) in fileTypeList"
                 :key="`fileType_${fileTypeItem.fileType}`"
                 :class="{'is-disabled': !fileTypeItem.allowCancel}"
                 @click="clickCheck(fileTypeItem, fileTypeIndex)">
              <el-checkbox v-model="fileTypeItem.checked">{{fileTypeItem.name}}</el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'ComponentDeliverySignatureContent',
  components: {},
  mixins: [],
  props: {
    // 主题 light / dark
    effect: {
      type: String,
      default: 'light'
    },
    // 是否在上传模块上。
    isUploadModule: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 是否自动送达文书
      deliveryFlag: '',
      // 当前文书类型列表
      fileTypeList: [],
    };
  },
  computed: {
    ...mapState({
      actId: state => state.user.actId,
      // 开通文书类型
      openDocType: state => state.user.openDocType,
    }),
  },
  watch: {},
  created() {
    this.init();
    // created
  },
  beforeDestroy() {
    // beforeDestroy
  },
  methods: {
    init() {
      this.fileTypeList = [];
      this.openDocType.forEach(fileType => {
        this.fileTypeList.push({
          fileType,
          name: this.$constant.FILE_TYPE[String(fileType)],
          // 选中状态
          checked: fileType.toString() === '73',
          // 是否允许取消
          allowCancel: fileType.toString() !== '73',
        });
      });
    },
    clickChangeRadio(type) {
      this.deliveryFlag = type;
      this.changeEmitHandler();
    },
    // 点击文书类型
    clickCheck(fileTypeItem, fileTypeIndex) {
      // 如果当前是否送达文书选择的不是"是"，不做任何操作。
      if (this.deliveryFlag !== '1') {
        return false;
      }
      // 如果当前是不允许取消的类型并且已经选中状态下，不做任何操作
      if (!fileTypeItem.allowCancel && fileTypeItem.checked) {
        return false;
      }
      fileTypeItem.checked = !fileTypeItem.checked;
      // 更新数据
      this.fileTypeList.splice(fileTypeIndex, 1, fileTypeItem);
      this.changeEmitHandler();
    },
    // 告诉外面当前数据变化内容
    changeEmitHandler() {
      const detailType = [];
      this.fileTypeList.forEach(fileTypeItem => {
        if (fileTypeItem.checked) {
          detailType.push(fileTypeItem.fileType);
        }
      });
      this.$emit('change', {
        deliveryFlag: this.deliveryFlag,
        detailType
      });
    }
    // methods end
  }
};
</script>

<style scoped lang="scss">
.jp-delivery-signature-box {
  padding-bottom: 16px;

  &:last-child {
    padding-bottom: 0;
  }

  .title {
    width: 100%;
    height: 14px;
    color: #999;
    font-size: 14px;
    line-height: 14px;
    user-select: none;
  }

  .jp-delivery-signature-content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    .jp-delivery-signature-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 12px;
      width: calc(50% - 6px);
      height: 46px;
      color: #333;
      font-size: 14px;
      text-align: center;
      border-radius: 2px;
      border: 1px solid #eee;
      cursor: pointer;
      user-select: none;
      background: #fff;
      span {
        margin-top: 4px;
        color: #666;
      }

      &.is-active {
        color: #274ea4;
        border-color: #274ea4;
      }
    }
  }
}
//送达范围
.jp-delivery-signature-range {
  height: 120px;
  .jp-delivery-signature-range-content {
    padding: 12px;
    position: relative;
    background: #fff;
    border: 1px solid #EEEEEE;
    &::before {
      content: '';
      position: absolute;
      left: 127px;
      top: -9px;
      display: block;
      width: 16px;
      height: 16px;
      background: linear-gradient(to bottom left, #fff 50%, transparent 50%);
      border: 1px solid #EEEEEE;
      border-left-width: 0;
      border-bottom-width: 0;
      transform: rotate(-45deg);
    }
  }
  .title {
    margin-bottom: 12px;
    color: #999;
    font-size: 14px;
    line-height: 14px;
  }
  .jp-delivery-signature-range-checkbox-list {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    .jp-delivery-signature-range-checkbox-item {
      position: relative;
      margin-right: 24px;
      margin-bottom: 12px;
      height: 16px;
      cursor: pointer;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: block;
        z-index: 1;
      }
      &.is-disabled {
        cursor: not-allowed;
        /deep/ .el-checkbox__inner {
          opacity: 0.5;
        }
      }
      /deep/ .el-checkbox {
        .el-checkbox__label {
          color: #777;
          line-height: 16px;
        }
        &.is-checked {
          .el-checkbox__label {
            color: #333;
          }
        }
      }
    }
  }
}
.jp-delivery-signature-bg {
  padding:  16px;
  background: #F5F7FA;
}
.jp-reminder-tip-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 24px;
  padding: 0 8px;
  width: 100%;
  height: 32px;
  color: #333;
  font-size: 14px;
  border-radius: 1px;
  background: rgba(226,129,3,0.08);
  user-select: none;
  i {
    font-size: 14px;
    margin-right: 4px;
    color: #F68F00;
  }

  .jp-reminder-tip-content {
    color: #333;

    span {
      color: #F68F00;
    }
  }
}
//暗色模式
.jp-delivery-signature-dark {
  .jp-delivery-signature-box {
    .title {
      color: #999;
    }

    .jp-delivery-signature-content {
      .jp-delivery-signature-item {
        border-color: #404040;
        color: rgba(255,255,255,0.7);
        background: transparent;

        &.is-active {
          color: #fff;
          border-color: #fff;
          &.is-multiple {

            &::after {
              background: url("~@/images/common/icon-select--checked--light@2x.png") right bottom no-repeat;
              background-size: 14px 12px;
            }
          }
        }

        &.is-disabled {
          border-color: #404040;
          color: rgba(255,255,255,0.4);
          background: rgba(216, 216, 216, 0.1);
        }
        &:not(.is-active):not(.is-disabled):hover {
          color: #fff;
          border-color: #fff;
        }
      }
    }
  }
  .jp-reminder-tip-container {
    background: rgba(226,129,3,0.2);
    .jp-reminder-tip-content {
      color: rgba(255, 255, 255, 0.7);
    }
  }
  .jp-delivery-signature-bg {
    background: rgba(247, 248, 250, 0.04);
  }
  .jp-delivery-signature-range {
    .jp-delivery-signature-range-content {
      //background: rgba(247, 248, 250, 0.06);
      background: #323237;
      border-color: #404040;
      &::before {
        background: linear-gradient(to bottom left, #323237 50%, transparent 50%);
        border-color: #404040;
      }
    }
    .jp-delivery-signature-range-checkbox-item {
      /deep/ .el-checkbox {
        .el-checkbox__label {
          color: rgba(255, 255, 255, 0.7);
        }
        .el-checkbox__inner {
          opacity: 0.2;
        }
        &.is-checked {
          .el-checkbox__inner {
            opacity: 1;
          }
          .el-checkbox__label {
            color: #fff;
          }
        }
      }
      &.is-disabled {
        cursor: not-allowed;
        /deep/ .el-checkbox {
          .el-checkbox__inner {
            opacity: 0.2;
          }
        }
      }
    }
  }
}

</style>
